import React from 'react';
import ChartDatasetSettings from '../../settings_sidebar/ChartDatasetSettings.jsx';
import { DEFAULT_ADDITIONAL_SETTINGS } from '../../settings_sidebar/chart/ChartSettings.jsx';

function BarChartDatasetWidgetSettings({ widgetId }) {
    return (
        <ChartDatasetSettings
            widgetId={widgetId}
            chart_settings_props={{
                chart_type: 'bar',
                additional_settings: [...DEFAULT_ADDITIONAL_SETTINGS, "columns", "grip_options", "number_format", "xaxis_labels", "display_labels_on_data"],
                column_options: ["single", "clustered", "clustered_aggregated", "stacked", "stacked_aggregated"],
                x_axis_labels_options: ["on_axis", "on_legend", "numbered_legend"],
                display_labels_on_data_options: ["without_labels", "with_labels"]
            }}
        />
    )
}

export default BarChartDatasetWidgetSettings;
